import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import Slider from "react-slick";
import useMedia from "use-media";
import { ModalClose } from "../../atoms/modalClose";
import { ErrorMassage } from "../../molecules/errorMassage";
import { Label } from "../../../components/atoms/label";
import "../../../resources_membership_hotel/css/popup/roomList.css"
import messageConst from "../../../const/messageConst";

const RoomDetailPopupContainer = (props) => {
    const {
        state,
        onClickCloseRoomDetailPopup,
    } = props;
    const useMediaFlag = useMedia({ maxWidth: '820px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const roomInfo = state.roomDetailPopup ? state.roomInfo : {};
    const popupRef = useRef(null);
    const [errorInfo, setErrorInfo] = useState({ errorFlg: false, errorMessageBox: [] });

    const settings = {
        infinite: true,
        arrows: true,
        speed: 500,
        slidesToScroll: 1,
        // centerMode: true,
        // centerPadding: "20%",
    };

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);
    useEffect(() => {
        popupRef.current.scrollTop = 0;
        setErrorInfo({ errorFlg: false, errorMessageBox: [] });
        let sliderEle = document.getElementsByClassName("slick-list");
        if(sliderEle.length) {
            sliderEle[0].style.height = "auto";
        }
        let arrowEle = document.getElementsByClassName("slick-prev");
        if(arrowEle.length) {
            arrowEle[0].style.zIndex = "1";
        }

    }, [state.roomDetailPopup]);

    return (
        <div className={state.roomDetailPopup ? "restaurantPopupIsShow" : "popup"} id="js-popup">
            <div ref={popupRef} className={isMobilePhone ? "inputUserPopupInner_media" : "inputUserPopupInner"}>
                <div className="popupHeader">
                    <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={onClickCloseRoomDetailPopup} />
                    <h4 className="popupInnerText" >部屋詳細</h4>
                </div>
                <div className={errorInfo.errorFlg ? "errorDiv" : "hiddenItem"}>
                    <ErrorMassage data={errorInfo.errorMessageBox} />
                </div>
                <div className="popupBodyWrapper">
                    <Slider {...settings}>
                        {
                            roomInfo.roomTypeGazoList?.map((roomImage, index) => (
                                <div key={"courseImage" + index} className="listDetailPopupImgWrap">
                                    <img src={roomImage} alt="" className="listDetailPopupImg" />
                                </div>
                            ))
                        }
                    </Slider>
                    <div className="roomDetailWrapper">
                        <Label
                            label={roomInfo.rmTypeExp}
                            className={roomInfo.rmTypeExp ? "rmTypeExp" : "hiddenItem"}
                        />
                        <Label
                            label={roomInfo.rmTypeExpURL}
                            className={roomInfo.rmTypeExpURL ? "rmTypeExp2" : "hiddenItem"}
                        />
                        <Label
                            label={`グレード：${roomInfo.roomGradeNam}`}
                            className="roomInfoLabel"
                        />
                        {roomInfo.mensekiMin || roomInfo.mensekiMax ?
                            <Label
                                label={roomInfo.mensekiMin == roomInfo.mensekiMax || (roomInfo.mensekiMin && !roomInfo.mensekiMax) ? `客室面積：${roomInfo.mensekiMin}平米`
                                    : (!roomInfo.mensekiMin && roomInfo.mensekiMax) ? `客室面積：${roomInfo.mensekiMax}平米`
                                        : `客室面積：${roomInfo.mensekiMin}～${roomInfo.mensekiMax}平米`}
                                className="roomInfoLabel"
                            />
                            : null}
                        <div className="roomInfoIconList">
                            {roomInfo.kinenFlg ?
                                <Label
                                    label="禁煙　"
                                    className="roomInfoLabel"
                                />
                                : null
                            }
                            {roomInfo.dogDohanFlg ?
                                <Label
                                    label="愛犬可　"
                                    className="roomInfoLabel"
                                />
                                : null
                            }
                            {roomInfo.roomOnsenFlg ?
                                <Label
                                    label="温泉付客室　"
                                    className="roomInfoLabel"
                                />
                                : null
                            }
                        </div>
                        <Label
                            label={"部屋タイプ：" + roomInfo.roomTypeCdNam}
                            className="roomInfoLabel"
                        />
                        <Label
                            label={`定員：${roomInfo.hyojiyoTeiin}名`}
                            className="roomInfoLabel"
                        />
                        <Label
                            label={roomInfo.hyojiyoTeiinSetsumei}
                            className="roomInfoLabel"
                        />
                        {roomInfo.roomPrice ?
                            <Label
                                label={`料金：￥${roomInfo.roomPrice ? roomInfo.roomPrice?.toLocaleString() : 0}（税込）`}
                                className="roomInfoLabel"
                            />
                            :
                            <>
                                <div className="roomDetailPrice">
                                    <Label
                                        label={"料金："}
                                        className="roomInfoLabel"
                                    />
                                    <div>
                                        <Label
                                            label={`メンバー様　￥${roomInfo.roomPriceMmb ? roomInfo.roomPriceMmb?.toLocaleString() : 0}（税サ込）`}
                                            className="roomInfoLabel"
                                        />
                                        <Label
                                            label={`ゲスト様　￥${roomInfo.roomPriceGuest ? roomInfo.roomPriceGuest?.toLocaleString() : 0}（税サ込）`}
                                            className="roomInfoLabel"
                                        />
                                    </div>
                                </div>
                            </>
                        }
                        <Label
                            label={messageConst.ROOM_PRICE_MESSAGE}
                            className="roomInfoLabelRed"
                        />
                        <Label
                            label={messageConst.BAYCOURT_ROOM_PRICE_MESSAGE}
                            className={roomInfo.roomPriceMmb && roomInfo.roomPriceGuest ? "roomInfoLabelRed" : "hiddenItem"}
                        />
                        <Label
                            label={messageConst.ROOM_IMAGE_MESSAGE}
                            className="roomInfoLabelRed"
                        />
                    </div>
                </div>
            </div>
            <div className="blackBackground" id="js-black-bg"></div>
        </div >
    );
};

const mapStateToProps = (state) => {
    return {
        login: state.login,
        inputUserInfo: state.inputUserInfo,
        inputRoomList: state.inputRoomList,
        membershipSearchParam: state.membershipSearchParam,
        membershipReserveInfo: state.membershipReserveInfo,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setInputUserInfo: (item) => {
            dispatch({ type: "INPUT_USER_INFO", payload: { inputUserInfo: item } })
        },
        setInputRoomList: (item) => {
            dispatch({ type: "INPUT_ROOM_LIST", payload: { inputRoomList: item } })
        },
        setMembershipSearchParam: (item) => {
            dispatch({ type: "MEMBERSHIP_SEARCH_PARAM", payload: { membershipSearchParam: item } })
        },
        setMembershipReserveInfo: (item) => {
            dispatch({ type: "MEMBERSHIP_RESERVE_INFO", payload: { membershipReserveInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(RoomDetailPopupContainer);